import identity from 'ramda/src/identity';
import ifElse from 'ramda/src/ifElse';
import max from 'ramda/src/max';
import compose from 'ramda/src/compose';
import replace from 'ramda/src/replace';

const check = function ( str ) {
    if ( typeof str !== 'string' ) {
        throw Error( 'Invalid argument: StringUtils requires a string argument' );
    }

    return true;
};

export const validatePostalCode = function ( postalCode ) {
    const regex = /^\d{5}(-\d{4})?$/;
    return regex.test( postalCode );
};

export const validateEmail = function ( email ) {
    check( email );

    const re = /^\S+@\S+$/;
    return re.test( email );
};

export const toTitleCase = ( str ) => {
    check( str );

    return str.replace( /\w\S*/g, ( txt ) => {
        return txt.charAt( 0 ).toUpperCase() + txt.substr( 1 ).toLowerCase();
    } );
};

export function formatPhoneUS ( phoneNumber ) {
    const match = /(\d{3})(\d{3})(\d{4})/.exec( phoneNumber );
    if ( !match || match.length !== 4 ) {
        return phoneNumber;
    }

    return `(${match[1]}) ${match[2]}-${match[3]}`;
}

export function trimFormData ( obj = {} ) {
    const newObj = {};

    for ( let key in obj ) {
        if ( typeof obj[key] !== 'string' ) {
            newObj[key] = obj[key];
            continue;
        }
        newObj[key] = obj[key].trim();
    }

    return newObj;
}

export function reverseString ( str ) {
    check( str );
    return str.split( '' ).reverse().join( '' );
}

export function truncateStringByChar ( str, maxLen = 100 ) {
    check( str );

    const len = max( 0, maxLen );
    if ( str.length > len ) {
        // find last word boundary starting at specified length and trim
        return str.substr( 0, len ).replace( /\s+\w+$/, '' );
    }

    return str;
}

export function truncateStringByLine ( str, maxLen = 3 ) {
    check( str );

    // match lines with at least 1 carriage return
    const matchedLines = str.match( /.*[\r\n]{1,2}/gm );
    const len = max( 0, maxLen );
    if ( matchedLines && matchedLines.length >= len ) {
        return matchedLines
            .slice( 0, len )
            .reduce( ( acc, next ) => acc += next, '' )
            .trim();
    }

    return str;
}

export function truncateString ( str, maxCharLen, maxLineLen ) {
    check( str );

    return truncateStringByChar(
        truncateStringByLine( str, maxLineLen ),
        maxCharLen
    );
}

// only replace "-" or "/" that appear between words (word chars) leaving other values
// such as SKU or Serial Numbers unchanged that may have a combination of numbers and word chars
export const wordsFromSlug = compose( replace( /(?!=[a-z][^0-9]+)[-/](?=[a-z][^0-9]+)/gi, ' ' ), decodeURIComponent );

export const toTitleFromSlug = compose( toTitleCase, wordsFromSlug );